module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-page-slider"
  }, [(_vm.slides[0] && _vm.slides[0].image) ? _c('swiper', {
    attrs: {
      "options": _vm.swiperOption
    }
  }, _vm._l((_vm.slides), function(slide, index) {
    return _c('swiper-slide', {
      key: index,
      staticClass: "slide",
      style: ({
        'background-image': 'radial-gradient(100% 30% at top left, oklch(0.18 0.06 258.68 / 0.8) 10%, transparent 122%), url(' + slide.image + ')'
      })
    }, [_c('div', {
      staticClass: "slider-caption"
    }, [_c('h2', {
      style: ({
        color: _vm.customization.mainColor
      }),
      attrs: {
        "data-swiper-parallax": "-100%"
      }
    }, [_vm._v("\n          " + _vm._s(slide.slideTitle) + "\n        ")]), _vm._v(" "), _c('span', {
      staticClass: "subtitle",
      attrs: {
        "data-swiper-parallax": "-60%"
      }
    }, [_vm._v(_vm._s(slide.slideSubTitle))]), _vm._v(" "), (slide.slideText) ? _c('div', {
      staticClass: "divider",
      style: ({
        'background-color': _vm.customization.mainColor
      })
    }) : _vm._e(), _vm._v(" "), _c('p', {
      attrs: {
        "data-swiper-parallax": "-30%"
      }
    }, [_vm._v("\n          " + _vm._s(slide.slideText) + "\n        ")])]), _vm._v(" "), (index === 0) ? _c('referral-panel', {
      attrs: {
        "data-swiper-parallax": "-100%"
      }
    }) : _vm._e()], 1)
  }), 1) : _vm._e(), _vm._v(" "), (_vm.slides && _vm.slides.length) ? _c('div', {
    staticClass: "swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  }) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-39d68894", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39d68894"}!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/src/components/home-page-components/home-page-slider.component.vue
// module id = 813
// module chunks = 0